import { CostBasisMethods } from '@interfaces/models/cost-basis-methods';
import { CostBasisPosition } from '@store/reducers/cost-basis/cost-basis.reducer';
import { MXMState } from '@store/reducers/mxm/mxm.reducer';

export const getGiftingOverviewNextPage = (): string => 'gifting/triage';
export const getGiftingTriageNextPage = (): string => 'gifting/summary';
export const getGiftingAssetsNextPage = (): string => 'secure/gifting/method/1';
export const getGiftingRecipientNextPage = (): string => 'secure/gifting/review';

export enum RedirectUrls {
  INTELLEDOX = 'secure/gifting/intelledox-redirect',
  ESIGN = 'secure/gifting/terms/gift-existing',
  ESIGN_MULTI_SIGNER = 'secure/gifting/terms/gift-existing-multisigner',
}

export const getGiftingReviewNextPage = (mxmState: MXMState): string => {
  const isMXM2Flow: boolean = mxmState.signState !== null && mxmState.transferId !== null;

  return isMXM2Flow ? RedirectUrls.ESIGN_MULTI_SIGNER : RedirectUrls.ESIGN;
};

export const getGiftingTermsNextPage = (mxmState: MXMState): string => {
  const isMXM2Flow: boolean = mxmState.signState !== null && mxmState.transferId !== null;

  return isMXM2Flow ? `secure/gifting/confirm-multisigner` : 'secure/gifting/confirm';
};
export const getGiftingRecipientTriageNextPage = (): string => 'secure/gifting/recipient';
export const getGiftingAdditionalInstructionsNextPage = (): string =>
  'secure/gifting/recipient-triage';
export const getGiftingMethodNextPage = (
  selectedPositions: CostBasisPosition[],
  isAdvisedClient: boolean,
): string => {
  const hasSpecIdMethod = selectedPositions.some(
    (position) => position.selectedCostBasisMethod === CostBasisMethods.SPECID,
  );

  if (isAdvisedClient && hasSpecIdMethod) {
    return 'secure/gifting/additional-instructions';
  }

  return 'secure/gifting/recipient-triage';
};
